(function () {
  var BOTTOM_UP = '80px';

  function getGorgiasEls() {
    var results = [];
    document.querySelectorAll('[id*="gorgias"],[class*="gorgias"],iframe[src*="gorgias"],iframe[name*="gorgias"]').forEach(function (el) {
      var target = el.closest('[style*="position: fixed"],[style*="position:fixed"]') || el;
      if (results.indexOf(target) === -1) results.push(target);
    });
    return results;
  }

  function setChatBottom(pushed) {
    getGorgiasEls().forEach(function (el) {
      if (pushed) {
        el.style.setProperty('bottom', BOTTOM_UP, 'important');
      } else {
        el.style.removeProperty('bottom');
      }
    });
  }

  function isStickyBarVisible() {
    var bar = document.querySelector('.sticky-add-to-cart__bar[data-stuck="true"]');
    return !!bar;
  }

  function addCroChatClass() {
    var btn = document.querySelector('#chat-button, [id*="gorgias"] button, [class*="gorgias"] button, iframe[src*="gorgias"]');
    if (btn && !btn.classList.contains('cro-chat')) btn.classList.add('cro-chat');
  }

  function update() {
    setChatBottom(isStickyBarVisible());
    addCroChatClass();
  }

  function observeStickyBar() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return false;
    new MutationObserver(update).observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    update();
    return true;
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        var isGorgias = (node.id && node.id.includes('gorgias')) ||
                        (node.className && typeof node.className === 'string' && node.className.includes('gorgias')) ||
                        node.querySelector('[id*="gorgias"],[class*="gorgias"]');
        if (isGorgias) update();
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  var ticks = 0;
  var iv = setInterval(function () {
    if (observeStickyBar() || ++ticks >= 60) clearInterval(iv);
  }, 500);

  window.addEventListener('gorgias:loaded', update);
})();
